import { Koi } from '@ksyos/koi';
import { FundusScreeningThirdParty } from '@common/fundusScreening/thirdParties';
import type { ISchemaContainer } from './schemaContainer';
import { replaceKoiError } from './replaceKoiError';

export type FundusScreeningManualImportFrontendSchemaValidated = {
    file: File;
    isInvalidFile: boolean;
    thirdParty: FundusScreeningThirdParty;
};

export type FundusScreeningGetManualImportSortByKeys = (typeof fundusScreeningGetManualImportLogsSortByKeys)[number];

export const fundusScreeningManualImportFrontendSchema: ISchemaContainer<FundusScreeningManualImportFrontendSchemaValidated> =
    {
        schema: Koi.object({
            file: Koi.object()
                .required()
                .error((errors) => replaceKoiError(errors, 'object.base', 'fileRequired')),
            thirdParty: Koi.koi().enum(FundusScreeningThirdParty).required(),
        }),
    };

export const fundusScreeningGetManualImportLogsSortByKeys = [
    'importDate',
    'thirdParty.name',
    'importedFileName',
    'group.name',
    'invitationType',
    'modifierPractitioner.nameFamily',
] as const;

export const fundusScreeningGetManualImportLogsSortByOptionsSchema = Koi.object({
    sortByKey: Koi.string()
        .valid(...fundusScreeningGetManualImportLogsSortByKeys)
        .required(),
    sortDirection: Koi.string().valid('asc', 'desc').required(),
})
    .allow(null)
    .optional();
